import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import cloneDeep from 'lodash/cloneDeep';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
import { group } from 'console';

interface DealCorrectionsState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;
    documents: any[];
    schema: any;

    meta: any;
}

const state: DealCorrectionsState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,
    documents: [],
    schema: null,
    meta: {},
};

const initState: any = cloneDeep(state);

const DEAL_DATA = 'DEAL_DATA';

export function productDetails(docId: string) {
    const columns: any = {
      product_name: 'p.name',
      product_container_name: 'pc.name',
      corrections: {$array_agg: {
        $obj: {
          id: 'dpcc.id',
          is_sample: 'dpcc.is_sample',
          container_quantity: 'dpcc.container_quantity',
          container_weight: {$mul: ['pc.weight', 'dpcc.container_quantity']},
          container_price: 'dpcc.container_price',
          notes: 'dpcc.notes',
          sample_date: 'dpcc.sample_date',
          // approve_comment: 'dpcc.approve_comment',
          is_deleted: 'dpcc.is_deleted',
          employee_name: 'e.name',
          created_at: 'dpcc.created_at',
        }
      }}
    };
  
    return {
        columns,
        from: 's:deal_product_containers_corrections',
        from_as: 'dpcc',
        joins: [
          {
            join: 's:product_containers',
            type: 'left',
            as:   'pc',
            on: {
              $eq: ['pc.id', 'dpcc.product_container_id']
            }
          },
          {
            join: 's:products',
            type: 'left',
            as:   'p',
            on: {
                $eq: ['pc.product_id', 'p.id']
            }
          },
          {
            join: 's:employees',
            type: 'left',
            as:   'e',
            on: {
                $eq: ['dpcc.employee_id', 'e.id']
            }
          },
        ],
        groups: [
          'p.name',
          'pc.name',
        ],
        pageSize: 10000,
        order: [
          {$asc: ['p.name']},
          {$asc: ['pc.name']},
        ],
        where: {
          $eq: [`dpcc.deal_id`, {$: docId}]
        }
    }
  }

export const actions: ActionTree<DealCorrectionsState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    loadData({ commit, getters, dispatch, state }, { documentId }) {
        const vm = (this as any)._vm;

        state.documentId = documentId;

        return new Promise((resolve, reject) => {
          vm.$db([
            vm.$q(DEAL_DATA)
                .raw('documents.list')
                .action(productDetails(documentId)),
          ]).then((result: ServerResult) => {

            commit('SET_DEAL_DATA', result.getOperation(DEAL_DATA).getContent());
            commit('LOADED_SUCCESS');

            resolve(null);
          });
        })
    },

};

export const mutations: MutationTree<DealCorrectionsState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },
  SET_DEAL_DATA(state, data) {
      const schema = data.schema;
      state.meta = fetchEnumsFromSchema(schema);

      state.schema = schema
      state.documents = data.documents.map((row: any) => {
        row.corrections = row.corrections.sort((a: any, b: any) => {
            const keyA = parseInt(a.id.split(':')[2])
            const keyB = parseInt(b.id.split(':')[2])
            if (keyA > keyB) {
              return 1
            } else if (keyA < keyB) {
              return -1
            }
            return 0
        })
        return row
      })
  },
};

export const getters: GetterTree<DealCorrectionsState, RootState> = {
  
};

export const STORE_KEY = '$_deal_corrections';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
